import React, {useEffect,useState, useRef} from 'react';
import { REPORT_TYPE_SET } from '../../../config/ReportOptionSet';
import Checkbox from '../checkbox/Checkbox';
import './ListItem.css';
import DropdownQRSInfo from '../../container/dropdown/dropdown-admin-qrsinfo/DropdownQRSInfo';

const QueryTypeIcon = (props) => {
  switch (props.query_type) {
    case "BASIC":{
      return(
        <span className="type_basic">
          {props.query_type}
        </span>
      )
    }
    case "BOOLEAN":{
      return(
        <span className="type_bool">
        {props.query_type}
      </span>
      )
    }
    default:
      return null;
  }
}

const ReportTypeIcon = (props) => {
  switch (props.report_type) {
    case "volume":{
      return(
        <span className="type_volu">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "sentiment":{
      return(
        <span className="type_sent">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "source":{
      return(
        <span className="type_sour">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "relation":{
      return(
        <span className="type_wordcloud">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "category":{
      return(
        <span className="type_cate">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "positioningmap":{
      return(
        <span className="type_positioning">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "buzzlist":{
      return(
        <span className="type_buzzlist">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    default:
      return null;
  }
}

const ListItem = (props) => {
  let itemForm;
  const [subItemOn, setSubItemOn] = useState(false);

  useEffect(() => {
    setSubItemOn(false)
  },[props.item])

  switch(props.type){
      case "HomeNotice": {
        if(props.index<6) itemForm = (<div>{props.item.title} {props.item.date}</div>)
        else return null;
        break;
      }
      case "HomeTopTen": {
        itemForm = (<div>{props.index+1} {props.item.keyword} {props.item.rate}</div>)
        break;
      }
      case "HomeMyQuery": {
        if(props.index<6) itemForm = (<div>{props.item.title} {props.item.date}</div>);
        else return null;
        break;
      }
      case "HomeMyReport": {
        if(props.index<6) itemForm = (<div>{props.item.title} {props.item.reportType} {props.item.date}</div>);
        else return null;
        break;
      }
      case "UserItem": {
        itemForm = (
          <li className="user-item">
            {props.item.company ?
              <div className="user-item-ingroup">
                <div onClick={()=>props.handleClick(props.item)} >
                  {`${props.item.fullname} (${props.item.email})`} 
                </div>
              </div>
              :
              <>
                <div onClick={()=>props.handleClick(props.item)} >
                  {`${props.item.fullname} (${props.item.email})`} 
                </div>
              </>
            }
          </li>
        )
        break;
      }
      case "SnapshotItem": {
        itemForm = (
          <li className="snapshot-item">
              {props.item.label ?
                <div className="snapshot-item-ingroup">
                  <div onClick={()=>props.handleClick(props.item)} >
                    {props.item.name}
                  </div>
                </div>
              : 
                <>
                  <div onClick={()=>props.handleClick(props.item)} >
                    {props.item.name}
                  </div>
                </>
              }
          </li>
          )
        break;
      }
      case "SnapshotItem-QRSInfo": {
        itemForm = (
          <li className="snapshot-item">
              {props.item.label ?
                <div className="snapshot-item-ingroup">
                  <div onClick={()=>props.handleClick(props.item)} >
                    <DropdownQRSInfo name={props.item.name} type={props.item.type} content={props.item.content}/>
                  </div>
                </div>
              : 
                <>
                  <div onClick={()=>props.handleClick(props.item)} >
                    <DropdownQRSInfo name={props.item.name} type={props.item.type} content={props.item.content}/>
                  </div>
                </>
              }
          </li>
          )
        break;
      }
      case "CustomItem": {
        itemForm = (
          <li className="custom-item">
              {props.item.label ?
                <div className="custom-item-ingroup">
                  <div onClick={()=>props.handleClick(props.item)} >
                    {props.item.name}
                  </div>
                </div>
              : 
                <>
                  <div onClick={()=>props.handleClick(props.item)} >
                    {props.item.name}
                  </div>
                </>
              }
          </li>
          )
        break;
      }
      case "ReportItem": {
        itemForm = (
          <li className="report-item">
              {props.item.label ?
                <div className="report-item-ingroup">
                  <div onClick={()=>props.handleClick(props.item)} >
                    {props.item.name}&nbsp;&nbsp;&nbsp;<ReportTypeIcon report_type={props.item.REPORT_TYPE} />
                  </div>
                </div>
              : 
                <>
                  <div onClick={()=>props.handleClick(props.item)} >
                    {props.item.name}&nbsp;&nbsp;&nbsp;<ReportTypeIcon report_type={props.item.REPORT_TYPE} />
                  </div>
                </>
              }
          </li>
          )
        break;
      }
      case "ReportItem-QRSInfo": {
        itemForm = (
          <li className="report-item">
              {props.item.label ?
                <div className="report-item-ingroup">
                  <div onClick={()=>props.handleClick(props.item)} >
                    <DropdownQRSInfo name={props.item.name} type={props.item.REPORT_TYPE} function={props.item.function} reportID={props.item.reportID} content={props.item.content}/>&nbsp;&nbsp;&nbsp;<ReportTypeIcon report_type={props.item.REPORT_TYPE} />
                  </div>
                </div>
              : 
                <>
                  <div onClick={()=>props.handleClick(props.item)} >
                    <DropdownQRSInfo name={props.item.name} type={props.item.REPORT_TYPE} function={props.item.function} reportID={props.item.reportID} content={props.item.content}/>&nbsp;&nbsp;&nbsp;<ReportTypeIcon report_type={props.item.REPORT_TYPE} />
                  </div>
                </>
              }
          </li>
          )
        break;
      }
      case "QueryItem": {
        itemForm = (
          <li className="query-item">
              {props.item.label ?
                <div className="query-item-ingroup">
                  <div onClick={()=>props.handleClick(props.item)} >
                    {props.item.name}&nbsp;&nbsp;&nbsp;<QueryTypeIcon query_type={props.item.QUERY_TYPE} />
                  </div>
                </div>
              : 
                <>
                  {!props.checkdisable && <Checkbox className="list-checkbox" checked={props.item.checked} id={`query-checkbox-${props.item.queryID}`} handleCheckBox={props.handleCheckBox} />}
                  <div onClick={()=>props.handleClick(props.item)} >
                    {props.item.name}&nbsp;&nbsp;&nbsp;<QueryTypeIcon query_type={props.item.QUERY_TYPE} />
                  </div>
                </>
              }
          </li>
          )
        break;
      }
      case "QueryItem-QRSInfo": {
        itemForm = (
          <li className="query-item">
              {props.item.label ?
                <div className="query-item-ingroup">
                  <div onClick={()=>props.handleClick(props.item)} >
                    <DropdownQRSInfo name={props.item.name} type={props.item.QUERY_TYPE} content={props.item.content}/>&nbsp;&nbsp;&nbsp;<QueryTypeIcon query_type={props.item.QUERY_TYPE} />
                  </div>
                </div>
              : 
                <>
                  {!props.checkdisable && <Checkbox className="list-checkbox" checked={props.item.checked} id={`query-checkbox-${props.item.queryID}`} handleCheckBox={props.handleCheckBox} />}
                  <div onClick={()=>props.handleClick(props.item)} >
                    <DropdownQRSInfo name={props.item.name} type={props.item.QUERY_TYPE} content={props.item.content}/>&nbsp;&nbsp;&nbsp;<QueryTypeIcon query_type={props.item.QUERY_TYPE} />
                  </div>
                </>
              }
          </li>
          )
        break;
      }
      case "CompanyItem": {
        itemForm =(
          <>
            <div className="company-user-item">
              <div onClick={()=>{setSubItemOn(!subItemOn)}}>
                <span>
                  <strong>{props.item.company}&nbsp;&nbsp;({props.item.labelItem.length})</strong>
                </span>
              </div>
            </div>
            {subItemOn && props.item.labelItem.map((subItem, subIndex) => {
              return(
                <ul>
                  <ListItem handleClick={props.handleClick} type={props.item.labelItemType} key={subItem.name+subIndex} item={subItem} index={subIndex} />
                </ul>
              )
            })}
          </>
        )
        break;
      }
      case "BuzzLabelReportItem":{
        itemForm = (
          <>
            <div className="buzz-label-report-item">
              <div onClick={()=>{setSubItemOn(!subItemOn)}}>
                <span>
                  <strong>{props.item.name}&nbsp;&nbsp;({props.item.labelItem.length})</strong>
                </span>
              </div>
            </div>
            {subItemOn && props.item.labelItem.map((subItem, subIndex) => {
              return(
                <ul>
                  <ListItem handleClick={props.handleClick} type={props.item.labelItemType} key={subItem.name+subIndex} item={subItem} index={subIndex} />
                </ul>
              )
            })}
          </>
        )
        break;
      }
      case "BuzzLabelItem": {
        itemForm = (
          <>
            <div className="buzz-label-item">
              {!props.checkdisable && <Checkbox className="list-checkbox" checked={props.item.checked} id={`label-checkbox-${props.item.labelID}`} handleCheckBox={props.handleCheckBox} />}
              <div onClick={()=>{setSubItemOn(!subItemOn)}}>
                <span>
                  <strong>{props.item.name}&nbsp;&nbsp;({props.item.labelItem.length})</strong>
                </span>
              </div>
            </div>
            {subItemOn && props.item.labelItem.map((subItem, subIndex) => {
              return(
                <ul>
                  <ListItem handleClick={props.handleClick} type={props.item.labelItemType} key={subItem.name+subIndex} item={subItem} index={subIndex} />
                </ul>
              )
            })}
          </>
        )
        break;
      }
      case "BuzzLabelSnapshotItem":{
        itemForm = (
          <>
            <div className="buzz-label-snapshot-item">
              <div onClick={()=>{setSubItemOn(!subItemOn)}}>
                <span>
                  <strong>{props.item.name}&nbsp;&nbsp;({props.item.labelItem.length})</strong>
                </span>
              </div>
            </div>
            {subItemOn && props.item.labelItem.map((subItem, subIndex) => {
              return(
                <ul>
                  <ListItem handleClick={props.handleClick} type={props.item.labelItemType} key={subItem.name+subIndex} item={subItem} index={subIndex} />
                </ul>
              )
            })}
          </>
        )
        break;
      }
      case "BuzzLabelCustomItem":{
        itemForm = (
          <>
            <div className="buzz-label-custom-item">
              <div onClick={()=>{setSubItemOn(!subItemOn)}}>
                <span>
                  <strong>{props.item.name}&nbsp;&nbsp;({props.item.labelItem.length})</strong>
                </span>
              </div>
            </div>
            {subItemOn && props.item.labelItem.map((subItem, subIndex) => {
              return(
                <ul>
                  <ListItem handleClick={props.handleClick} type={props.item.labelItemType} key={subItem.name+subIndex} item={subItem} index={subIndex} />
                </ul>
              )
            })}
          </>
        )
        break;
      }
      case "BuzzLabelItemSetting" :{
        itemForm = (
          <li>
            <div className="buzz-label-setting-item">
              <div onClick={()=>props.handleClick(props.item)}>
                {props.item.name}
              </div>
            </div>
          </li>
        )
        break;
      }
      default: {
        itemForm = null;
        break;
      }
  }
  return (
    <>
      {itemForm}
    </>
  )
}

export default ListItem;